import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const steps = [
  { num: 'process_step1_num', title: 'process_step1_title', subtitle: 'process_step1_subtitle', desc: 'process_step1_desc', icon: 'ri-search-line' },
  { num: 'process_step2_num', title: 'process_step2_title', subtitle: 'process_step2_subtitle', desc: 'process_step2_desc', icon: 'ri-file-list-3-line' },
  { num: 'process_step3_num', title: 'process_step3_title', subtitle: 'process_step3_subtitle', desc: 'process_step3_desc', icon: 'ri-calendar-schedule-line' },
  { num: 'process_step4_num', title: 'process_step4_title', subtitle: 'process_step4_subtitle', desc: 'process_step4_desc', icon: 'ri-delete-bin-line' },
  { num: 'process_step5_num', title: 'process_step5_title', subtitle: 'process_step5_subtitle', desc: 'process_step5_desc', icon: 'ri-home-smile-line' },
  { num: 'process_step6_num', title: 'process_step6_title', subtitle: 'process_step6_subtitle', desc: 'process_step6_desc', icon: 'ri-shield-check-line' },
];

export default function Process() {
  const { t } = useTranslation('refection');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="process" className="bg-white py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl mb-3">
            {t('process_h2')}
          </h2>
        </div>

        {/* Image banner */}
        <div
          className={`rounded-xl overflow-hidden mb-10 md:mb-14 transition-all duration-1000 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <img
            src="https://readdy.ai/api/search-image?query=Professional%20roofing%20crew%20replacing%20an%20old%20roof%20on%20a%20Quebec%20house%2C%20workers%20removing%20old%20shingles%20and%20installing%20new%20ones%2C%20construction%20scaffolding%20and%20safety%20equipment%2C%20active%20roofing%20site%20with%20debris%20disposal%2C%20warm%20overcast%20daylight%2C%20documentary%20construction%20photography%2C%20no%20text%20visible&width=1000&height=350&seq=ref-proc1&orientation=landscape"
            alt="Équipe de couvreurs en pleine réfection de toiture à Lévis par couvreurs partenaires RBQ"
            className="w-full h-48 md:h-64 object-cover object-top"
            loading="lazy"
            width="1000"
            height="350"
            width="1000"
            height="350"
          />
        </div>

        <div className="relative">
          {/* Ligne verticale */}
          <div className="absolute left-6 md:left-8 top-0 bottom-0 w-px bg-soft-dark" />

          <div className="space-y-8 md:space-y-12">
            {steps.map((step, idx) => (
              <div
                key={idx}
                className={`relative flex gap-5 md:gap-8 transition-all duration-1000 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${idx * 150}ms` }}
              >
                {/* Cercle numéro */}
                <div className="relative flex-shrink-0">
                  <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-slate-primary border-4 border-white shadow-md flex items-center justify-center relative z-10">
                    <span className="text-white font-bold text-sm md:text-base">
                      {t(step.num)}
                    </span>
                  </div>
                </div>

                {/* Contenu */}
                <div className="flex-1 pt-1 md:pt-2">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <h3 className="font-manrope font-bold text-slate-primary text-base md:text-lg">
                      {t(step.title)}
                    </h3>
                    <span className="bg-copper/15 text-copper font-semibold text-xs px-2.5 py-1 rounded-full whitespace-nowrap">
                      {t(step.subtitle)}
                    </span>
                  </div>
                  <p className="text-slate-primary/60 text-sm md:text-base leading-relaxed max-w-xl">
                    {t(step.desc)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}